// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1rFnx","location":"Header_location__2b556"};